import {createSelector} from 'reselect'
import {AppState} from 'redux/config'
import {URLOption} from './state'

export const select_diagnostics = (state: AppState) => state.diagnostics
export const select_selectedUrl = (state: AppState) => state.diagnostics.selectedUrl
export const select_selectedScript = (state: AppState) => state.diagnostics.selectedScript
export const select_diagnosticResults = (state: AppState) => state.diagnostics.diagnosticResults
export const select_columnsconfig = (state: AppState) => state.diagnostics.columnsConfig
export const select_gridSession = (state: AppState) => state.diagnostics.gridSession
export const select_status = (state: AppState) => state.diagnostics.status
export const select_error = (state: AppState) => state.diagnostics.error
export const select_totalCount = (state: AppState) => state.diagnostics.totalCount
export const select_gridSession_pagination = (state: AppState) => state.diagnostics.gridSession.pagination
export const select_gridSession_sorting = (state: AppState) => state.diagnostics.gridSession.sorting
export const select_gridSession_columnOrder = (state: AppState) => state.diagnostics.gridSession.columnOrder
export const select_gridSession_filters_searchQuery = (state: AppState) => state.diagnostics.gridSession.filters.searchQuery
export const select_shouldRunDiagnostic = (state: AppState) => state.diagnostics.shouldRunDiagnostic
export const select_showDetailsPanel = (state: AppState) => state.diagnostics.showDetailsPanel
export const select_diagnosticDetailsItem = (state: AppState) => state.diagnostics.diagnosticDetailsItem

export const select_diagnosticScriptOptions = (state: AppState) =>
  state.diagnostics.diagnosticScriptOptions

export const select_urlOptions = createSelector(
  select_diagnostics,
  (diagnostics): URLOption[] => {
    return diagnostics.urlOptions || []
  }
)
